/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import { AffiliateApi } from "@/api/affiliates";
import { DataProvider } from "react-admin";
import { ResourceName } from "../react-admin.util";

const dataProvider: DataProvider = {
  getList: async (_, params) => {
    const { pagination, sort, filter } = params;

    const users = await AffiliateApi.getAffiliateUsers({
      ...filter,
      page: pagination?.page,
      perPage: pagination?.perPage,
      sortBy: sort?.field,
      sortDirection: sort?.order.toLowerCase(),
    });

    return { data: users.data, total: users.meta.total };
  },
  getMany: () => {
    return new Promise((res) => res);
  },
  getOne: async () => {
    return new Promise((res) => res);
  },
  create: () => {
    return new Promise((res) => res);
  },
  update: () => {
    return new Promise((res) => res);
  },
  updateMany: () => {
    return new Promise((res) => res);
  },
  delete: () => {
    return new Promise((res) => res);
  },
  deleteMany: () => {
    return new Promise((res) => res);
  },
  getManyReference: () => {
    return new Promise((res) => res);
  },
};

export const affiliateUsersResourceProvider = {
  resource: ResourceName.AFFILIATE_USERS,
  dataProvider,
};
